module.exports = __webpack_public_path__ + "img/ramhee_thumb.272aa373.png";